<template>
  <div class="product-section">
    <div class="df vertical df-around">
      <div class="title">{{ query.localDate }} 物料缺货情况</div>

      <a-space>
        <select-day
          :defaultVal="query.localDate"
          @userDelectDay="userSelectDay"
        ></select-day>
        <a-select
          @change="handleUpdateShotage"
          v-model:value="query.shortage"
          placeholder="请选择缺货状态"
          style="width: 140px"
          allowClear
        >
          <a-select-option value="缺货">缺货</a-select-option>
          <a-select-option value="正常">正常</a-select-option>
        </a-select>
        <a-button @click="handleUpdateAbnormalProblem(null)">新增</a-button>
      </a-space>
    </div>
    <form-vue
      ref="fqcRef"
      @updateTable="updateTable"
      :type="props.type"
    ></form-vue>
    <div ref="tableScrollRef">
      <div class="df both-side" style="margin-top: 20px">
        <div
          :style="{
            width: `${tableScrollWidth}px`,
          }"
          style="margin: 0 auto"
        >
          <a-table
            :columns="productColumns"
            :loading="tableLoading"
            :data-source="tableData"
            :pagination="false"
            :rowClassName="
              (record, index) => (index % 1 === 0 ? 'table-striped' : null)
            "
            rowKey="id"
            bordered
            :scroll="{ x: tableScrollWidth }"
          >
            <template #action="{ record }">
              <a-space>
                <a-button @click="handleEdit(record)" size="small"
                  >编辑</a-button
                >

                <a-button
                  v-if="props.deleteAuthority"
                  @click="handleDelete(record)"
                  type="danger"
                  size="small"
                  >删除</a-button
                >
              </a-space>
            </template>

            <template #notes="{ record }">
              <div v-if="record.notes">
                <template
                  v-for="(item, index) in JSON.parse(record.notes)"
                  :key="index"
                >
                  <a-image
                    v-for="img in JSON.parse(item.picture)"
                    :key="img"
                    :width="50"
                    :src="img"
                  />

                  <video
                    v-for="video in JSON.parse(item.video)"
                    :src="video"
                    controls
                    width="120"
                    :key="video"
                  ></video>

                  <div>
                    {{ item.desc }}
                  </div>
                </template>
              </div>
            </template>
          </a-table>

          <div class="df both-side">
            <div></div>
            <a-pagination
              size="small"
              style="margin-top: 10px"
              :total="query.total"
              v-model:current="query.pageNum"
              v-model:pageSize="query.lineNum"
              @change="handleUpdatePage"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, reactive, ref, inject, watch } from "vue";
import {
  getMaterialShortageList,
  deleteMaterialShortage,
} from "@/request/view/product";
import searchVue from "@/views/productDaily/components/quality/PQC/threePieced/search.vue";
import formVue from "@/views/productDaily/components/product/components/materialShortage/form.vue";
import SelectDay from "@/views/repairprogress/compoments/selectDay.vue";
import { useStore } from "vuex";
import { showModal } from "@/views/repairprogress/serve/modal";
import { Toast, debounce, timeStampToTime } from "@/utils";

export default defineComponent({
  props: {
    type: String,
    deleteAuthority: Boolean,
  },
  components: {
    searchVue,
    formVue,
    SelectDay,
  },
  setup(props, context) {
    const query = reactive({
      localDate: null,
      type: props.type,
      lineNum: 10,
      pageNum: 1,
      shortage: null,
      total: 0,
    });
    const store = useStore();

    const userId = computed(() => store.state.user.user.id);

    const productColumns = [
      {
        title: "序号",
        dataIndex: "id",
        width: 80,
        align: "center",
      },
      {
        title: "物料名称",
        dataIndex: "name",
        width: 165,
        align: "center",
      },
      {
        title: "物料编码",
        dataIndex: "materialCode",
        width: 165,
        align: "center",
      },
      {
        title: "物料批号",
        dataIndex: "materialBatch",
        width: 165,
        align: "center",
      },
      {
        title: "SN号",
        dataIndex: "snNumber",
        width: 165,
        align: "center",
      },
      {
        title: "线上数量",
        dataIndex: "onlineNumber",
        width: 120,
        align: "center",
      },
      {
        title: "需求数量",
        dataIndex: "demandNumber",
        width: 120,
        align: "center",
      },
      {
        title: "需求日期",
        dataIndex: "demandDate",
        width: 120,
        align: "center",
      },
      {
        title: "供应商发货日期",
        dataIndex: "supplierDeliveryDate",
        width: 140,
        align: "center",
      },
      {
        title: "缺货状态",
        dataIndex: "shortage",
        width: 120,
        align: "center",
      },
      {
        title: "备注",
        dataIndex: "notes",
        width: 165,
        align: "center",
        slots: {
          customRender: "notes",
        },
      },
      {
        title: "操作",
        slots: {
          customRender: "action",
        },
        width: 110,
        align: "center",
        fixed: "right",
      },
    ];

    const tableLoading = ref(false);

    const searchRef = ref();

    const fqcRef = ref();

    const tableScrollRef = ref();

    const tableData = reactive([]);

    const tableScrollWidth = ref(window.screen.width - 80);

    const getTableData = () => {
      tableLoading.value = true;
      getMaterialShortageList({
        type: query.type,
        lineNum: query.lineNum,
        pageNum: query.pageNum,
        shortage: query.shortage,
        localDate: query.localDate,
      })
        .then((res) => {
          tableLoading.value = false;
          tableData.length = 0;
          if (res.code === 200 && res.message === "成功") {
            tableData.push(...res.data.records);
            query.total = res.data.total;
          }
        })
        .catch((err) => {
          tableLoading.value = false;
          console.log(err, "报错");
        });
    };

    const handleDelete = (record) => {
      showModal({
        title: "提示",
        toastText: "确认删除？",
        success: () => {
          deleteMaterialShortage([record.id])
            .then((res) => {
              Toast(res.code === 200 ? "success" : "warning", res.message, 3);
              if (res.code === 200) {
                getTableData();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        },
      });
    };

    const handleUpdateShotage = () => {
      getTableData();
    };

    const userSelectDay = (time) => {
      if (time) {
        query.localDate = time;
        getTableData();
      } else {
        query.localDate = timeStampToTime("", "upload");
        getTableData();
      }
    };

    const handleEdit = (data) => {
      fqcRef.value.openModal("editMaterialShortage", data);
    };

    const handleUpdateAbnormalProblem = () => {
      fqcRef.value.openModal("addMaterialShortage");
    };

    const updateTable = () => {
      getTableData();
    };

    const handleUpdatePage = (page, pagesize) => {
      query.pageNum = page;
      getTableData();
    };

    const tabActivekey = inject("tabActivekey", null);
    watch(
      () => tabActivekey,
      (val) => {
        if (val.value === props.type) {
          getTableData();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      props,
      query,
      userId,
      handleDelete,
      userSelectDay,
      handleUpdateShotage,
      productColumns,
      searchRef,
      fqcRef,
      tableData,
      tableLoading,
      tableScrollRef,
      handleUpdateAbnormalProblem,
      updateTable,
      handleEdit,
      tableScrollWidth,
      handleUpdatePage,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
